<template>
  <div>
    <h3 v-if="showTitle" class="detail-info-title">Assembly Instructions</h3>
    <p>
      View
      <a :href="product.assemblyInstructionsUrl" target="_blank" @click="onClicked" class="link">assembly instructions</a>
      (PDF)
    </p>
  </div>
</template>

<script>
import Tracking from '@/components/commons/Tracking';

export default {
  name: 'ProductAssembly',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    product: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onClicked() {
      Tracking.track('PDP_Download_Assembly', { device: window.screen.width < 967 ? 'Mobile' : 'Desktop' });
    },
  },
};
</script>

<style scoped>

  .link{
    text-decoration: underline;
    color: var(--coral);
  }
</style>
